import { convertFromRaw } from "draft-js";
import dynamic from "next/dynamic";
import Hero from "./components/Hero/Hero";
import Meta from "./components/Meta/Meta";
import Content from "./components/Content/Content";
import Footer from "../../components/Footer/Footer";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import { JobListing, JobSingle } from "../../../common/types";
import Cta from "./components/Cta/Cta";
import { istekaoOglas } from "../../../lib/slack";
import { useState } from "react";
import Modal from "../../components/Modal/Modal";
import ListItem from "../../components/ListItem/ListItem";

const SocialShare = dynamic(
    () => import("../../components/SocialShare/SocialShare"),
    { ssr: false }
);

export default function Job({
    data,
    similarJobs,
}: {
    data: JobSingle;
    similarJobs: JobListing[];
}) {
    const [prijavljen, setPrijavljen] = useState(false);

    const oKompanijiNotEmpty =
        JSON.parse(data.oKompaniji) &&
        convertFromRaw(JSON.parse(data.oKompaniji)).hasText();

    const opisNotEmpty =
        JSON.parse(data.opisPosla) &&
        convertFromRaw(JSON.parse(data.opisPosla)).hasText();

    const kvalifikacijeNotEmpty =
        JSON.parse(data.kvalifikacije) &&
        convertFromRaw(JSON.parse(data.kvalifikacije)).hasText();

    const informacijeNotEmpty =
        JSON.parse(data.informacije) &&
        convertFromRaw(JSON.parse(data.informacije)).hasText();

    const prijaviOglas = () => {
        setPrijavljen(true);
        const link = `https://www.dzobs.com/posao/${data?.meta.companySlug}/${data?.slug}/`;
        istekaoOglas(link, data?.title);
        2;
    };

    return (
        <div className="relative bg-white">
            <Hero
                title={data.title}
                meta={data.meta}
                slug={data.slug}
                tags={data.tagsList}
                cities={data.citiesList}
                premium={data.meta.companyPlan === "PREMIUM"}
            />
            <Meta meta={data.meta} />
            <div className="pt-16">
                {oKompanijiNotEmpty && (
                    <Content title="O kompaniji" content={data.oKompaniji} />
                )}
                {opisNotEmpty && (
                    <Content title="Opis posla" content={data.opisPosla} />
                )}
                {kvalifikacijeNotEmpty && (
                    <Content
                        title="Kvalifikacije"
                        content={data.kvalifikacije}
                    />
                )}
                {informacijeNotEmpty && (
                    <Content
                        title="Dodatne Informacije"
                        content={data.informacije}
                    />
                )}
                <div className="max-w-screen-md mx-auto px-6 lg:px-0 mb-8 leading-loose italic">
                    <p>
                        Oglas istekao?&nbsp;
                        <button
                            className="underline"
                            onClick={() => setPrijavljen(true)}
                        >
                            Prijavi ovdje.
                        </button>{" "}
                    </p>
                </div>
                {prijavljen && (
                    <Modal
                        type="report"
                        action={prijaviOglas}
                        cancel={() => setPrijavljen(false)}
                    />
                )}
            </div>
            <Cta cta={data.cta} title={data.title} />

            {!data.isPremium && (
                <div className="max-w-screen-md mx-auto px-6 lg:px-0 mb-16 leading-loose">
                    <h2 className="mb-6 mt-12 font-medium text-2xl">
                        Slični Oglasi
                    </h2>
                    {similarJobs
                        ? similarJobs?.map((job) => (
                              <ListItem key={job.id} job={job} />
                          ))
                        : "Loading..."}
                </div>
            )}

            <Newsletter bg="bg-gray-light" />
            <Footer />
            <SocialShare title={data.title} />
        </div>
    );
}
